import useTheme from '../SharedUtils/hooks/useTheme';

export const useSubtitleClasses = (initialClass, fields) => {
  const { isLight } = useTheme();

  const subTitleClasses = [initialClass];

  subTitleClasses.push(
    fields.SubTitleLeftAlign?.value ? 'c-subtitle--align-left' : 'c-subtitle--align-center'
  );

  const isInverted = isLight
    ? fields.SubTitleInvertedLight?.value
    : fields.SubTitleInvertedDark?.value;
  subTitleClasses.push(isInverted ? 'c-subtitle-inverted' : 'c-subtitle-default');

  switch (fields.SubTitleStyleOverride?.value) {
    case 'Markets Style Default':
      subTitleClasses.push('c-subtitle-override-default');
      break;
    case 'Markets Style Inverted':
      subTitleClasses.push('c-subtitle-override-inverted');
      break;
    default:
      break;
  }

  return subTitleClasses;
};
